import request from '@/utils/request'
const apiPath = '/cust/patient-file'
import { downloadBlob } from '@/utils/download'
const patientApi = {
  /**
   * 新增【患者档案】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【患者档案】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【患者档案】
   */
  fetchList(query) {
    return request.get(apiPath + '/list', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【患者档案】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
}
export default patientApi

